/** Bounded, multi-reader edit history. A reader that falls behind must refresh
 * once from the authoritative model; no reader consumes another one's edits. */
export class ChangeJournal<T> {
  private batches: Array<{ version: number; ids: T[] }> = [];
  private floor = 0;
  private count = 0;
  private latest = 0;

  record(version: number, ids?: Iterable<T>) {
    this.latest = version;
    if (!ids) {
      this.batches = [];
      this.count = 0;
      this.floor = version;
      return;
    }
    const batch = { version, ids: [...new Set(ids)] };
    this.batches.push(batch);
    this.count += batch.ids.length;
    while (this.batches.length > 128 || this.count > 8192) {
      const removed = this.batches.shift()!;
      this.count -= removed.ids.length;
      this.floor = removed.version;
    }
  }

  since(version: number): Set<T> | undefined {
    if (version < this.floor || version > this.latest) return undefined;
    const result = new Set<T>();
    for (const batch of this.batches)
      if (batch.version > version) for (const id of batch.ids) result.add(id);
    return result;
  }
}
